import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { Box } from "@mui/material";

import { Heading, Image, Item, List, Text } from "../../components/elements";
import { Table, Tbody, Td, Th, Thead, Tr } from "../../components/elements/Table";
import { get_date } from "../../components/generalComponets";
import { DownloadAndPrint } from "../../components/DownloadAndPrint";
import { CardLayout } from "../../components/v3";
import { CRMService } from "../../services";
import { CompanyLogo } from "../../components/shared";

interface ClientInvoiceData {
  id?: string;
  date?: string;
  amount?: string | number;
  description?: string;
  company?: { name: string };
  client?: { name: string; primaryPhone?: string };
  project?: { name: string };
}

export const ClientInvoiceInfo = () => {
  const [invoiceData, setInvoiceData] = useState<Partial<ClientInvoiceData>>({});

  const printRef = useRef<HTMLDivElement>(null);
  const { id } = useParams();

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const incomeResponse = await CRMService.getClientReceivablesById(id);
      setInvoiceData(incomeResponse.data);
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };

  const thead = ["SL NO", "Description", "quantity", "amount", "total"];

  const handlePrint = useReactToPrint({
    contentRef: printRef,
  });
  return (
    <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
      <CardLayout sx={{ padding: 0 }}>
        <div ref={printRef} style={{ padding: "22px" }}>
          <Box className="mc-invoice-head">
            <CompanyLogo type="icon" alt={"logo"} plain={true} />
            <Heading as="h2">{"invoice"}</Heading>
          </Box>

          <Box className="mc-invoice-group">
            <Box className="mc-invoice-recieved">
              <Heading as="h6">{invoiceData?.company?.name}</Heading>
              {/* <Text>{companyPlace}</Text> */}
            </Box>
            <Box className="mc-invoice-shipment">
              <Heading as="h6">Client</Heading>
              <Text>{invoiceData?.client?.name}</Text>
              <Text>{invoiceData?.client?.primaryPhone}</Text>
            </Box>
          </Box>

          <Box className="mc-invoice-group">
            <Box>
              <Text>Date: {get_date(invoiceData.date)}</Text>
              <Text>ID: #{invoiceData.id}</Text>
            </Box>
            {invoiceData.project && (
              <Box className="mc-invoice-shipment">
                <Heading as="h6">Project</Heading>
                <Text>{invoiceData?.project?.name}</Text>
              </Box>
            )}
          </Box>

          <Box className="mc-table-responsive">
            <Table className="mc-table">
              <Thead className="mc-table-head">
                <Tr>
                  {thead.map((item, index) => (
                    <Th key={index}>{item}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody className="mc-table-body">
                <Tr>
                  <Td>1</Td>
                  <Td>
                    <Box className="mc-table-product sm">
                      <Text>{invoiceData.description}</Text>
                    </Box>
                  </Td>
                  <Td>1</Td>
                  <Td>{Number(invoiceData.amount)}</Td>
                  <Td>{Number(invoiceData.amount)}</Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>

          <Box className="mc-invoice-list-group">
            <List className="mc-invoice-list">
              <Item>
                <Text as="span" className="title">
                  {"Total"}
                </Text>
                <Text as="span" className="clone">
                  :
                </Text>
                <Text as="span" className="digit total">
                  ₹ {Number(invoiceData.amount)}
                </Text>
              </Item>
            </List>
          </Box>
        </div>
      </CardLayout>

      {/* Print Button */}
      <DownloadAndPrint handlePrint={handlePrint} printRef={printRef} fileName={"ClientInvoiceInfo.pdf"} />
    </Box>
  );
};
